module.exports = __webpack_public_path__ + "media/images/career_camp/2022/dividers/steps_1-0dd8d3517b2ba6c614c1d0b311622ceb.svg";